module.exports = __webpack_public_path__ + "img/sword.dfdf8f64.svg";